var React = require('react');

function LawsOfTheGameInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("path",{"className":"cls-1","d":"M11.1,28V8.73H24.76V28l-6.83-6.22Zm1.42-17.88V24.82l5.41-4.92,5.41,4.92V10.15Z","key":1}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":2})]);
}

LawsOfTheGameInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = LawsOfTheGameInline;

LawsOfTheGameInline.default = LawsOfTheGameInline;
